import type {ReactNode} from "react";
import SaveButton, {SaveState} from "@/components/buttons/SaveButton.tsx";
import {Button} from "@/components/ui/button.tsx";

export default function FormToolbar({title, subtitle, navigation, actions, saveState, saveDisabled, onCancel}: {
    title: string;
    subtitle?: string;
    navigation?: ReactNode;
    actions?: ReactNode;
    saveState: SaveState;
    saveDisabled?: boolean;
    onCancel: () => void;
}) {
    return (
        <header className="flex shrink-0 flex-wrap items-center gap-3">
            <div className="min-w-0 shrink-0">
                <h1 className="truncate font-medium">{title}</h1>
                {subtitle && <p className="text-xs text-muted-foreground">{subtitle}</p>}
            </div>
            {navigation && <nav className="order-3 flex w-full justify-center md:order-none md:min-w-0 md:flex-1">
                {navigation}
            </nav>}
            <div className="ml-auto flex shrink-0 items-center gap-2">
                {actions}
                <Button type="button" variant="outline" size="sm" onClick={onCancel}>Schließen</Button>
                <SaveButton saveState={saveState} disabled={saveDisabled}/>
            </div>
        </header>
    );
}
